import React from 'react';
import { useTranslation } from 'react-i18next';
import DateTimePickerField from './DateTimePickerField';
import { useFormikContext } from 'formik';

interface DateTimeRangePickerProps {
  minStartDate?: string | Date;
  maxEndDate?: string | Date;
}

interface FormValues {
  startDate?: string;
  endDate?: string;
}

const DateTimeRangePicker: React.FC<DateTimeRangePickerProps> = ({
  minStartDate,
  maxEndDate
}) => {
  const { t } = useTranslation('events');
  const { values } = useFormikContext<FormValues>();

  const disabledStartDate = minStartDate ? new Date(minStartDate) : undefined;
  const disabledEndDate = maxEndDate ? new Date(maxEndDate) : undefined;
  const disabledStartForEndDate = values.startDate
    ? new Date(values.startDate)
    : disabledStartDate;

  return (
    <>
      <label htmlFor="startDate" className="text-sm">
        {t('settings.discountCodes.page.startDateTimeLabel')}
      </label>

      <DateTimePickerField
        name="startDate"
        disabledBefore={disabledStartDate}
        disabledAfter={disabledEndDate}
      />

      <div className="mt-4">
        <label htmlFor="endDate" className="text-sm">
          {t('settings.discountCodes.page.endDateTimeLabel')}
        </label>
        <DateTimePickerField
          name="endDate"
          disabledBefore={disabledStartForEndDate}
          disabledAfter={disabledEndDate}
        />
      </div>
    </>
  );
};

export default DateTimeRangePicker;
